import BaseValidator from 'services/validations/base-validator';
import Const from 'const';
import {getCheckedNumbers} from '../helpers';

class DefensemanExistsIfNeededValidator extends BaseValidator {
    private errorMessage: string =
        'There is not enough Defensemen for the selected teams to create lineups with 4 player stacks. Please choose more combinations, teams or include more players for selected teams.';

    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const combos = stacking.getCheckedCombinations();

        if (this.isThereComboWithoutMandatoryDefenseman(combos)) {
            return;
        }

        const stacks = stacking.getStacks();

        for (const stackNumber of Object.keys(stacks)) {
            const isStackWithMandatoryDefenseman = Number(stackNumber) === Const.NHL_TEAM_STACKING_FIRST_STACK;

            if (!isStackWithMandatoryDefenseman) {
                continue;
            }

            if (this.isStackInvalid(stackNumber)) {
                this.addError(this.errorMessage);
                break;
            }
        }
    }

    private isThereComboWithoutMandatoryDefenseman(combos): boolean {
        // @ts-ignore
        const {stacking} = this.dependencies;

        for (let combo of Object.values(combos)) {
            let isDefensemanMandatory = false;
            // @ts-ignore
            for (let stackNumber of Object.keys(combo.playersQuantity)) {
                if (stacking.isDefensemanMandatoryInCombinationStack(combo, stackNumber)) {
                    isDefensemanMandatory = true;
                    break;
                }
            }

            if (!isDefensemanMandatory) {
                return true;
            }
        }

        return false;
    }

    private isStackInvalid(stackNumber): boolean {
        // @ts-ignore
        const {stacking, playersGroupedByTeams} = this.dependencies;
        const stackTeams = stacking.getActiveAndCheckedTeamsByStackNumber(stackNumber);

        if (this.isThereTeamWithMinExpAndAbsentDefenseman(stackTeams, playersGroupedByTeams)) {
            return true;
        }

        return !this.isThereTeamWithAvailableDefenseman(stackTeams, playersGroupedByTeams);
    }

    private isThereTeamWithAvailableDefenseman(stackTeams, playersGroupedByTeams): boolean {
        for (const teamName of Object.keys(stackTeams)) {
            const isTherePlayersInTeam = playersGroupedByTeams.hasOwnProperty(teamName);

            if (!isTherePlayersInTeam) {
                continue;
            }

            if (this.isThereAvailableDefensemanInTeam(stackTeams[teamName], playersGroupedByTeams[teamName])) {
                return true;
            }
        }

        return false;
    }

    private isThereAvailableDefensemanInTeam(stackTeam, teamPlayers): boolean {
        const availableLineGroups = getCheckedNumbers(stackTeam.lineGroups);
        const availablePPLines = getCheckedNumbers(stackTeam.ppLines);

        if (isEmpty(availableLineGroups) && isEmpty(availablePPLines)) {
            return false;
        }

        for (const player of teamPlayers) {
            if (!player.isDefenseman()) {
                continue;
            }

            const isPlayerInLineGroup = inArray(Number(player.userLineGroup), availableLineGroups);
            const isPlayerInPPLine = inArray(Number(player.userPpLine), availablePPLines);

            if (isPlayerInLineGroup || isPlayerInPPLine) {
                return true;
            }
        }

        return false;
    }

    private isThereTeamWithMinExpAndAbsentDefenseman(stackTeams, playersGroupedByTeams): boolean {
        for (const teamName of Object.keys(stackTeams)) {
            const isTeamMinExpPositive = stackTeams[teamName].exposure.min > 0;

            if (!isTeamMinExpPositive) {
                continue;
            }

            const teamPlayers = playersGroupedByTeams[teamName] ?? [];

            if (!this.isThereAvailableDefensemanInTeam(stackTeams[teamName], teamPlayers)) {
                return true;
            }
        }

        return false;
    }
}

export default DefensemanExistsIfNeededValidator;
